import axiosInstance from "@/lib/axios";

export const serviceService = {
  // Récupérer tous les services approuvés avec filtres
  getServices: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/services', { params });
    return response.data;
  },

  // ADMIN: Récupérer tous les services (y compris pending)
  getAdminServices: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/admin/services', { params });
    return response.data;
  },

  // Récupérer les détails d'un service spécifique
  getServiceDetails: async (id) => {
    const response = await axiosInstance.get(`/api/v1/services/${id}`);
    return response.data;
  },

  // ADMIN: Récupérer les détails d'un service (tous statuts)
  getAdminServiceDetails: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/services/${id}`);
    return response.data;
  },

  // Récupérer le service de l'utilisateur connecté
  getUserService: async () => {
    const response = await axiosInstance.get('/api/v1/user/service');
    return response.data;
  },

  // Créer un nouveau service
  createService: async (serviceData) => {
    const response = await axiosInstance.post('/api/v1/services', serviceData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Mettre à jour un service existant
  updateService: async (id, serviceData) => {
    const response = await axiosInstance.put(`/api/v1/services/${id}`, serviceData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Supprimer un service
  deleteService: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/services/${id}`);
    return response.data;
  },

  // ADMIN: Supprimer une vidéo d'un service (modération)
  deleteServiceVideo: async (id, index) => {
    const response = await axiosInstance.delete(`/api/v1/admin/services/${id}/videos/${index}`);
    return response.data;
  },

    toggleServiceStatus: async (id) => {
    const response = await axiosInstance.patch(`/api/v1/services/${id}/toggle-status`);
    return response.data;
  },


  // Récupérer les services par prestation
  getServicesByPrestation: async (prestation, params = {}) => {
    const response = await axiosInstance.get(`/api/v1/services/prestation/${prestation}`, { params });
    return response.data;
  },

  // Récupérer les services par localisation
  getServicesByLocation: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/services/location', { params });
    return response.data;
  },

  // Services à proximité (avec géolocalisation)
  getNearbyServices: async (latitude, longitude, radius = 10, category = null) => {
    const response = await axiosInstance.post('/api/v1/services/nearby', {
      latitude,
      longitude,
      radius,
      category
    });
    return response.data;
  },

  // Liste des catégories disponibles
  getCategories: async () => {
    const response = await axiosInstance.get('/api/v1/services/meta/categories');
    return response.data;
  },

  // Liste des villes disponibles
  getCities: async () => {
    const response = await axiosInstance.get('/api/v1/services/meta/cities');
    return response.data;
  },

  // Mettre à jour uniquement la localisation
  updateLocation: async (id, locationData) => {
    const response = await axiosInstance.post(`/api/v1/services/${id}/location`, locationData);
    return response.data;
  },

  // Toggle disponibilité du service
  toggleAvailability: async (id) => {
    const response = await axiosInstance.post(`/api/v1/services/${id}/toggle-availability`);
    return response.data;
  },

  // Admin: Approuver un service
  approveService: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/services/${id}/approve`);
    return response.data;
  },

  // Admin: Rejeter un service
  rejectService: async (id, reason) => {
    const response = await axiosInstance.put(`/api/v1/admin/services/${id}/reject`, { reason });
    return response.data;
  },

  // Admin: Suspendre un service
  suspendService: async (id, reason) => {
    const response = await axiosInstance.put(`/api/v1/admin/services/${id}/suspend`, { reason });
    return response.data;
  },

  // Admin: Réactiver un service
  reactivateService: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/services/${id}/reactivate`);
    return response.data;
  },

  // Admin: Toggle featured
  toggleFeatured: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/services/${id}/toggle-featured`);
    return response.data;
  },

  // Admin: Toggle verified
  toggleVerified: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/services/${id}/toggle-verified`);
    return response.data;
  },

  // Admin: Obtenir statistiques
  getStatistics: async () => {
    const response = await axiosInstance.get('/api/v1/admin/services/statistics');
    return response.data;
  }
};